import React from 'react'
import './index.css'

const ListingTileSkeleton = () => {
    return (
        <div className='listing-tile skeleton'>
            <div className="listing-image skeleton" />
            <div className='listing-title skeleton' />
            <div className='listing-description skeleton' />
            <div className='listing-description skeleton' />
            <div className='listing-description skeleton' />
            <div className='listing-description skeleton' />
        </div>
    )
}

export default ListingTileSkeleton